import Navbar from '../../components/feature/Navbar';
import Footer from '../home/components/Footer';

export default function KitesurfLessons() {
  const courses = [
    {
      title: 'Discovery Course',
      duration: '3 Hours',
      price: '€90',
      icon: 'ri-compass-3-line',
      color: 'blue',
      features: [
        'Introduction to kitesurfing',
        'Wind theory & safety systems',
        'Kite control on land',
        'Body dragging in water',
        'All equipment included',
        'IKO certified instructor'
      ],
      level: 'Beginner'
    },
    {
      title: 'Full Course',
      duration: '9 Hours (3 days)',
      price: '€250',
      icon: 'ri-flight-takeoff-line',
      color: 'orange',
      features: [
        'Complete beginner to riding',
        'Water start techniques',
        'Board control & riding',
        'Safety & self-rescue',
        'All equipment included',
        'IKO certification available'
      ],
      level: 'Beginner to Intermediate',
      popular: true
    },
    {
      title: 'Advanced Coaching',
      duration: '2 Hours',
      price: '€80',
      icon: 'ri-rocket-2-line',
      color: 'teal',
      features: [
        'Jumping & tricks',
        'Wave riding techniques',
        'Freestyle maneuvers',
        'Video analysis',
        'All equipment included',
        'Expert coaching'
      ],
      level: 'Advanced'
    }
  ];

  const whyEssaouira = [
    {
      title: 'Perfect Wind Conditions',
      description: 'Consistent trade winds from April to October, ideal for kitesurfing',
      icon: 'ri-windy-line',
      color: 'blue'
    },
    {
      title: 'Shallow Lagoon',
      description: 'Safe, flat water perfect for learning and progression',
      icon: 'ri-water-percent-line',
      color: 'teal'
    },
    {
      title: 'Year-Round Spot',
      description: 'Warm climate and reliable conditions throughout the year',
      icon: 'ri-sun-line',
      color: 'orange'
    },
    {
      title: 'IKO Certified School',
      description: 'International Kiteboarding Organization approved center',
      icon: 'ri-medal-line',
      color: 'green'
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Navbar />

      {/* Hero Section */}
      <section className="relative h-[70vh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0">
          <img
            src="https://public.readdy.ai/ai/img_res/5c1d79d56ef8554e75528840f4e33d01.jpg"
            alt="Kitesurf Lessons"
            className="w-full h-full object-cover object-top"
          />
          <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        </div>
        <div className="relative z-10 text-center px-6 max-w-4xl mx-auto">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
            Master Kitesurfing in Essaouira
          </h1>
          <p className="text-xl text-white/95 mb-8 max-w-2xl mx-auto">
            Learn to fly with Morocco's premier IKO certified kitesurf school. Perfect wind, perfect waves, perfect location.
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="#courses"
              className="bg-gradient-to-r from-orange-500 to-orange-600 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:from-orange-600 hover:to-orange-700 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              View Courses
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-white text-gray-900 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              Contact Us
            </a>
          </div>
        </div>
      </section>

      {/* Why Essaouira Section */}
      <section className="py-20 bg-gradient-to-b from-white to-gray-50">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Why Learn in Essaouira?
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Essaouira is recognized worldwide as one of the best kitesurfing destinations
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {whyEssaouira.map((item, index) => (
              <div key={index} className="bg-white rounded-2xl p-8 shadow-lg hover:shadow-xl transition-all text-center">
                <div className={`w-16 h-16 flex items-center justify-center bg-${item.color}-100 rounded-full mx-auto mb-6`}>
                  <i className={`${item.icon} text-3xl text-${item.color}-600`}></i>
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{item.title}</h3>
                <p className="text-sm text-gray-600">{item.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section id="courses" className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Kitesurf Courses
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              From first flight to advanced tricks, we'll get you riding
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {courses.map((course, index) => (
              <div
                key={index}
                className={`relative bg-white rounded-2xl p-8 shadow-xl hover:shadow-2xl transition-all ${
                  course.popular ? 'border-2 border-orange-500' : 'border-2 border-gray-200'
                }`}
              >
                {course.popular && (
                  <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-gradient-to-r from-orange-500 to-orange-600 text-white px-6 py-2 rounded-full text-sm font-semibold whitespace-nowrap">
                    Best Value
                  </div>
                )}
                <div className="text-xs font-semibold text-gray-500 uppercase tracking-wide mb-3">
                  {course.level}
                </div>
                <div className={`w-16 h-16 flex items-center justify-center bg-${course.color}-100 rounded-full mb-6`}>
                  <i className={`${course.icon} text-3xl text-${course.color}-600`}></i>
                </div>
                <h3 className="text-2xl font-bold text-gray-900 mb-2">{course.title}</h3>
                <p className="text-sm text-gray-600 mb-4">{course.duration}</p>
                <div className="mb-6">
                  <span className="text-4xl font-bold text-gray-900">{course.price}</span>
                  <span className="text-base text-gray-600">/person</span>
                </div>
                <ul className="space-y-3 mb-8">
                  {course.features.map((feature, idx) => (
                    <li key={idx} className="flex items-start gap-3">
                      <i className="ri-checkbox-circle-fill text-teal-600 text-lg flex-shrink-0 mt-0.5"></i>
                      <span className="text-sm text-gray-700">{feature}</span>
                    </li>
                  ))}
                </ul>
                <a
                  href="/contact"
                  className={`block w-full text-center bg-gradient-to-r from-${course.color}-500 to-${course.color}-600 text-white py-4 rounded-full font-semibold text-base whitespace-nowrap hover:from-${course.color}-600 hover:to-${course.color}-700 transition-all shadow-lg hover:shadow-xl cursor-pointer`}
                >
                  Book Course
                </a>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Learning Path Section */}
      <section className="py-20 bg-gradient-to-b from-gray-50 to-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
              Your Learning Journey
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Step-by-step progression to independent riding
            </p>
          </div>

          <div className="max-w-4xl mx-auto">
            {[
              { level: 'Level 1', title: 'Kite Control', description: 'Master kite flying on land, understand wind window, and learn safety systems', icon: 'ri-kite-line' },
              { level: 'Level 2', title: 'Body Dragging', description: 'Control the kite in water, body drag upwind, and practice water relaunch', icon: 'ri-user-follow-line' },
              { level: 'Level 3', title: 'Water Start', description: 'Get up on the board, maintain balance, and ride your first meters', icon: 'ri-arrow-up-circle-line' },
              { level: 'Level 4', title: 'Independent Riding', description: 'Ride upwind, control speed and direction, and practice self-rescue', icon: 'ri-steering-2-line' },
              { level: 'Level 5', title: 'Advanced Skills', description: 'Jumping, transitions, tricks, and wave riding techniques', icon: 'ri-trophy-line' }
            ].map((step, index) => (
              <div key={index} className="flex gap-6 mb-8 last:mb-0">
                <div className="flex-shrink-0">
                  <div className="w-16 h-16 flex items-center justify-center bg-gradient-to-br from-orange-500 to-orange-600 rounded-full shadow-lg">
                    <i className={`${step.icon} text-2xl text-white`}></i>
                  </div>
                </div>
                <div className="flex-1 bg-white rounded-xl p-6 shadow-lg">
                  <div className="text-xs font-semibold text-orange-600 uppercase tracking-wide mb-2">
                    {step.level}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-2">{step.title}</h3>
                  <p className="text-sm text-gray-600">{step.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Safety Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-6">
          <div className="bg-gradient-to-r from-teal-500 to-teal-600 rounded-3xl p-12 text-center">
            <div className="w-20 h-20 flex items-center justify-center bg-white/20 rounded-full mx-auto mb-6">
              <i className="ri-shield-check-line text-4xl text-white"></i>
            </div>
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
              Safety First, Always
            </h2>
            <p className="text-lg text-white/95 max-w-2xl mx-auto mb-8">
              We follow strict IKO safety standards, use the latest equipment, and maintain small student-to-instructor ratios. Your safety is our top priority.
            </p>
            <div className="flex flex-wrap gap-6 justify-center text-white">
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">IKO Certified</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">Latest Equipment</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">Small Groups</span>
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-checkbox-circle-fill text-xl"></i>
                <span className="text-sm font-medium whitespace-nowrap">Radio Communication</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-orange-500 to-orange-600">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            Start Your Kitesurf Adventure Today
          </h2>
          <p className="text-xl text-white/95 mb-8">
            Join hundreds of students who learned to kitesurf with us in Essaouira
          </p>
          <div className="flex flex-wrap gap-4 justify-center">
            <a
              href="/contact"
              className="bg-white text-orange-600 px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-gray-100 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              Book Your Course
            </a>
            <a
              href="https://wa.me/212600000000"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 text-white px-8 py-4 rounded-full font-semibold text-base whitespace-nowrap hover:bg-green-600 transition-all shadow-lg hover:shadow-xl cursor-pointer"
            >
              <i className="ri-whatsapp-line mr-2"></i>
              WhatsApp Us
            </a>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
